import { Component, input } from '@angular/core';
import { VKratosUiTextWidget } from '../types';

/**
 * Renders a `text` UI node of a Kratos flow — in practice the TOTP secret
 * key of the settings flow, shown for manual authenticator entry.
 */
@Component({
  selector: 'v-kratos-text',
  template: `
    @let w = widget();

    <div class="flex flex-col gap-1">
      @if (w.label?.text; as label) {
        <span class="text-xs tracking-tight text-zinc-400">{{ label }}</span>
      }
      <code
        class="w-fit rounded-lg bg-zinc-800 px-2 py-1 font-mono text-sm break-all text-zinc-200"
        >{{ w.textAttributes.text.text }}</code
      >
    </div>
  `,
})
export class VKratosTextComponent {
  widget = input.required<VKratosUiTextWidget>();
}
